<template>
  <div class="" id="quick-link">
    <h4>Quick Link</h4>
    <ul class="">
      <li class=""><router-link class="" to="/">Central Committee</router-link></li>
      <li class=""><router-link class="" to="/about">Olympiads</router-link></li>
      <li class=""><router-link class="" :to="{name:'Syllabus'}">Syllabus</router-link></li>
      <li class=""><router-link class="" :to="{name:'Resources'}">Resources</router-link></li>
      <li class=""><router-link class="" to="/">About</router-link></li>
      <li class=""><router-link class="" :to="{name:'Gallery'}">Photo Gallery</router-link></li>
      <li class=""><router-link class="" to="/">Press Release</router-link></li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "QuickLink"
  }
</script>

<style scoped>
  #quick-link ul{
    list-style-type: square;
    list-style-position: inside;
  }

  #quick-link ul li{

  }

  #quick-link ul li a{
    text-decoration: none;
    color: #444444;
    font-weight: normal;
    font-size: 14px;
  }

  #quick-link ul li a:hover{
    color: navy;
    font-weight: bold;
  }

  @media print {
    #quick-link{
      display: none;
    }
  }
</style>